import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2QuoteIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 24.152 23.98",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 24.152),
    children: [/*#__PURE__*/jsx("path", {
      d: "m12.74.75a10.476 10.476 0 0 0 -8.91 16.011l-3.08 6.469 6.469-3.08a10.491 10.491 0 1 0 5.52-19.4z"
    }), /*#__PURE__*/jsx("path", {
      d: "m14.993 10.493a.75.75 0 1 0 0-1.5.75.75 0 1 0 0 1.5"
    }), /*#__PURE__*/jsx("path", {
      d: "m15.159 13.744a2.783 2.783 0 0 0 1.615-2.376c0-1.044-.557-2.375-1.842-2.375m-5.184 1.5a.75.75 0 1 0 0-1.5.75.75 0 1 0 0 1.5"
    }), /*#__PURE__*/jsx("path", {
      d: "m9.913 13.744a2.783 2.783 0 0 0 1.615-2.376c0-1.044-.557-2.375-1.842-2.375"
    })]
  });
};

export { PM2QuoteIcon };
//# sourceMappingURL=quote.js.map
